import { Dialog } from '@mui/material';
import ItemViewer from './Common/ItemViewer/ItemViewer';

const ProjectViewerCard = ({ open, projectId, onClose }) => {
  const handleClose = () => {
    onClose(); // Не закрываем при загрузке
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        // Игнорируем закрытие при клике по backdrop
        if (reason === 'backdropClick') {
          return;
        }
        // Разрешаем закрытие по другим причинам (например, Esc, если не отключён)
        handleClose();
      }}
      maxWidth='md'
      sx={{ minHeight: 300 }}
    >
      <ItemViewer
        appBarSX={{ top: 0 }}
        slug={'projects'}
        id={projectId}
        actions={['edit', 'close']}
        onClose={onClose}
      />
    </Dialog>
  );
};

export default ProjectViewerCard;
